import * as ReactService from "@intech/react-service";
import { EmpresaEntidade } from "../entidades/EmpresaEntidade";

class Empresa extends ReactService.BaseService {
  constructor() {
    super("Empresa");
  }

  BuscarTodas = () =>
    this.CreateRequest<EmpresaEntidade[]>(ReactService.RequestType.GET, `BuscarTodas`);

}

export const EmpresaService = new Empresa();
